<template>
<div>
  <Navbar :homePage="true" />
   <div v-scroll-spy="{
     data: 'section',
     time: 500,
     offset: 200
     }" v-section-selector="'section'">
   <Intro />
   <WhatIsSCAD />
   <Symptoms />
    <CaseStudies />
   <FAQ />
   <Test />
  
   <ContactUs />
  <Footer />
  </div>
      <!-- </Layout> -->
 
</div>
</template>

<script>
import Intro from '../components/sections/Intro.vue'
import WhatIsSCAD from '../components/sections/WhatIsSCAD.vue'
import Symptoms from '../components/sections/Symptoms.vue'
import FAQ from '../components/sections/FAQ'
import Test from '../components/sections/Test'
import ContactUs from '../components/sections/ContactUs.vue'
import CaseStudies from '../components/sections/CaseStudies.vue'
import Footer from '../components/Footer.vue'
import Navbar from '../components/Navbar.vue'
export default {
  metaInfo: {
    title: 'Home'
  },
  components: {
    Intro,
    Symptoms,
    FAQ,
    Test,
    CaseStudies,
    ContactUs,
    Footer,
    WhatIsSCAD,
    Navbar
  },
  data: () => ({
    section: 0
  })
}
</script>

<style lang="scss">
  
</style>
